import { render } from "./Dimakis.vue?vue&type=template&id=32eeb6bc"
import script from "./Dimakis.vue?vue&type=script&lang=js"
export * from "./Dimakis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__